export default {
  getNetworkAddress() {
    return this.state.networkAddress
  },

  setNetworkAddress(value) {
    this.state.networkAddress = value
  }
}
